import { Component, ComponentInterface, Element, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { CmsLink, TrackableContentId } from '../../types/global';

/**
 * @deprecated please use the CmsLink interface from the global.d.ts
 */
export interface Link extends TrackableContentId {
  src: string;
  title: string;
  target?: '_self' | '_blank';
  style?: 'text' | 'button-primary' | 'button-secondary' | 'button-cta';
  icon?: string;
  iconOption?: 'icon' | 'auto' | 'none';
  decoration?: 'none' | 'default';
}

export interface UiCmsLinkBody extends CmsLink {
  alignment?: 'left' | 'right' | 'center';
}

@Component({
  tag: 'ui-cms-link',
  styleUrl: 'ui-cms-link.scss',
})
export class UiCmsLink implements ComponentInterface {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsLinkBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Event({ eventName: 'anchorCall' }) anchorCallEvent: EventEmitter<{ name: string }>;

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  private onClick() {
    const linkIsInternal = this.body.src.startsWith('#');

    if (linkIsInternal) {
      this.anchorCallEvent.emit({
        name: this.body.src.replace('#', ''),
      });
    }

    this.track(linkIsInternal);
  }

  private track(linkIsInternal: boolean) {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Click Link',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: this.body.buttonVariant ? 'Button' : 'Link',
        elementLabel: this.body.title,
        ...(linkIsInternal && { target: `${this.body.contentId}.${this.body.title}` }),
        ...(!linkIsInternal && { externalTarget: this.body.src }),
        // customECommerceParameter: // TODO add e commerce param for Celum option
      },
      category: {
        area: 'Content',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  render() {
    return (
      <Host alignment={this.body.alignment} onClick={this.onClick.bind(this)}>
        {this.body.buttonVariant ? (
          <sd-button
            size="lg"
            href={this.body.src}
            target={this.body.target}
            variant={this.body.buttonVariant}
            title={this.body.title}
          >
            {this.body.iconPath && (
              <sd-icon library={window.ui.cmsState.iconLibrary} slot="icon-left" name={this.body.iconPath}></sd-icon>
            )}
            {this.body.title}
          </sd-button>
        ) : (
          <sd-link size="lg" href={this.body.src} target={this.body.target} inverted={this.inverted}>
            {this.body.iconPath && (
              <sd-icon library={window.ui.cmsState.iconLibrary} slot="icon-left" name={this.body.iconPath}></sd-icon>
            )}
            {this.body.title}
          </sd-link>
        )}
      </Host>
    );
  }
}
